module.exports = __webpack_public_path__ + "static/media/Frame 83.d6ee58ed.png";